import React, { useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { ISlHorizontalScrollCommand, ISlHorizontalScrollState, SlHorizontalScrollList } from '../../../../shared/public/SlHorizontalScrollList/SlHorizontalScrollList';
import { SlSliderArrows } from '../../../../shared/public/SlSliderArrows/SlSliderArrows';
import { CourseItemV2 } from '../CourseItemV2/CourseItemV2';

import s from './CoursesSlider.scss';
import { ILearningExperience, Container, AuthService } from '../../../../symphony';

interface ICoursesProps {
	courses: ILearningExperience[];
}

export function CoursesSlider({ courses }: ICoursesProps): JSX.Element {
	useStyles(s);
	const isLoggedIn = Container.take('global', AuthService).isLoggedIn();

	const [direction, setDirection] = useState<ISlHorizontalScrollCommand>();
	const [scrollState, setScrollState] = useState<ISlHorizontalScrollState>({
		hasLeftScroll: false,
		hasRightScroll: false,
	});

	const directionHandler = (data: ISlHorizontalScrollCommand) => {
		setDirection(data);
	};

	return (
		<div
			className={`le-courses-slider${isLoggedIn ? '' : ' non-logged'}`}
			sl-test-data="cmpCoursesSlider"
		>
			{scrollState.hasRightScroll && (
				<span className="le-courses-slider__shadow le-courses-slider__shadow--right" />
			)}
			{scrollState.hasLeftScroll && (
				<span className="le-courses-slider__shadow le-courses-slider__shadow--left" />
			)}
			<SlSliderArrows
				isShown={courses.length > 5}
				scrollState={scrollState}
				directionHandler={directionHandler}
			/>
			<SlHorizontalScrollList
				scroll={direction}
				onStateChange={setScrollState}
			>
				{courses.map((course) => (
					<CourseItemV2
						key={course.alias}
						course={course}
						showStatuse
					/>
				))}
			</SlHorizontalScrollList>
		</div>
	);
}
